var map = {
	"./E@2x.png": 37,
	"./ENE@2x.png": 38,
	"./ESE@2x.png": 39,
	"./N@2x.png": 40,
	"./NE@2x.png": 41,
	"./NNE@2x.png": 42,
	"./NNW@2x.png": 43,
	"./NW@2x.png": 44,
	"./S@2x.png": 45,
	"./SE@2x.png": 46,
	"./SSE@2x.png": 47,
	"./SSW@2x.png": 48,
	"./SW@2x.png": 49,
	"./W@2x.png": 50,
	"./WNW@2x.png": 51,
	"./WSW@2x.png": 52
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36;